const docTemplates = {
  searchTemplates: "חיפוש תבניות...",
  newTemplate: "תבנית חדשה",
  noTemplates: "אין תבניות",
  createFirst: "צור תבנית ראשונה",
  untitledTemplate: "תבנית ללא שם",
  total: "סה\"כ",
  backToPipeline: "חזרה לצינור",
  backToTemplates: "חזרה לתבניות",
  templateNotFound: "תבנית לא נמצאה",
  allStatuses: "כל הסטטוסים",
  statusDraft: "טיוטה",
  statusActive: "פעיל",
  statusArchived: "ארכיון",
  duplicate: "שכפל",
  archive: "ארכיון",
  copy: "עותק",
  addDescription: "הוסף תיאור...",
  addTag: "תגית...",
  saveVersion: "שמור גרסה",
  manageTemplates: "ניהול תבניות",
  useTemplate: "צור מתבנית",
  selectTemplate: "בחר תבנית",
  blankDocument: "מסמך ריק",
  orBlank: "או צור מסמך ריק",
  startFromScratch: "התחל מאפס ללא תבנית",
} as const;
export default docTemplates;
